// src/pages/Dodatki.tsx
import CategoryPage from './CategoryPage';

const Dodatki = () => {
  const subcategories = [
    {
      title: "Smolnati dodatki",
      imageSrc: "https://images.unsplash.com/photo-1632120399340-dd60f322e57e?auto=format&fit=crop&q=80",
      url: "/dodatki/smolnati"
    },
    {
      title: "Stekleni dodatki",
      imageSrc: "https://images.unsplash.com/photo-1583845112239-97ef1341b271?auto=format&fit=crop&q=80",
      url: "/dodatki/stekleni"
    },
    {
      title: "Keramični dodatki",
      imageSrc: "https://images.unsplash.com/photo-1586798532065-b3a32857c5c4?auto=format&fit=crop&q=80",
      url: "/dodatki/keramicni"
    },
    {
      title: "Kamniti dodatki",
      imageSrc: "https://images.unsplash.com/photo-1581912492723-688317ba2762?auto=format&fit=crop&q=80",
      url: "/dodatki/kamniti"
    },
    {
      title: "Leseni dodatki",
      imageSrc: "https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80",
      url: "/dodatki/leseni"
    },
    {
      title: "Kovinski dodatki",
      imageSrc: "https://images.unsplash.com/photo-1599638075338-c400e736d58b?auto=format&fit=crop&q=80",
      url: "/dodatki/kovinski"
    }
  ];

  return (
    <CategoryPage
      title="Dodatki"
      description="Dokončajte videz vaše kopalnice z našimi skrbno izbranimi dodatki, ki dodajo tisto posebno noto elegance."
      heroImage="https://images.unsplash.com/photo-1632120399340-dd60f322e57e?auto=format&fit=crop&q=80"
      subcategories={subcategories}
    />
  );
};

export default Dodatki;